import React from 'react';
import { connect } from 'react-redux';
import AsyncSelect from "react-select/async";
import HttpAPICall from '../../../services/HttpAPICall';
import axios from 'axios';
import ErrorValidation from '../../../services/ErrorValidation';
import Ax from '../../../components/hoc/Ax';
import ReactSelectStyle from '../../../components/ui/ReactSelectStyle';
import { HRM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import api from '../../../services/api';

class InputEmployeeSearch extends React.Component {
    
    constructor(props) {
        super(props);
        this.state                  =   {
            selectedEmployee            :   null,
            timer                       :   false,
            defaultOptions              :   [],
            
        };
        this.cancelToken            =   null;
        this.apiTimeout             =   null;
        this.emp_list_url           =   HRM_API_BASE_URL_2 + '/employee/list';
    }
    
    initParams                          =   (props)  =>  {
      
        this.setState({
            params                      :   {
                search_site_ids             :   props.search_site_ids && props.search_site_ids.length > 0 ?  [props.search_site_ids] : []
            }
        }, () => {
            if(this.props.loadDefaultOptions == true && !this.props.linkedEmployee) {
                this.getDefaultOptions();
            }
            if(this.props.loadDefaultOptions == true && this.props.linkedEmployee && this.props.linkedEmployee.length > 0) {
                this.setState({
                    defaultOptions:     this.displayStringSearch(this.props.linkedEmployee)
                });
            }
        });
    }
    
    componentDidMount() {
        
        this.initParams(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.search_site_ids !== this.props.search_site_ids) {
            this.initParams(nextProps);
        }
    }

    onInputChange                   =   (selectedOption)  =>  {
        this.props.changeEvent(selectedOption);
    }
    
    displayStringSearch             =   (employee)  =>  {
    
        return employee.map(employee => {
            return {
                label               :    employee.display_full_name,
                value               :    employee.enc_id,
                employee            :    employee
            };
        });
    };
    
    loadingOptions                  =   (inputText,callback)  =>  {
        if(inputText.length > 2) {
            clearTimeout(this.apiTimeout)
            if (this.cancelToken) {
                this.cancelToken.cancel("Operation canceled due to new request.")
            }
            this.cancelToken = axios.CancelToken.source();

            let params          =        {
                search_site_ids : this.props.search_site_ids && this.props.search_site_ids.length > 0 ? this.props.search_site_ids : [],
                search_by_text  : inputText, per_page: 50,
                transaction_datetime : this.props.transaction_date ? this.props.transaction_date : null,
            };
            
            this.apiTimeout  = setTimeout(() => {this.getLoadingOptions(params,callback)},1000);
        }
    }

    getLoadingOptions         =        (params,callback)            =>         {
         api.server2Api({
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + this.props.access_token },
                    params: params,
                    url: this.emp_list_url,
                    cancelToken: this.cancelToken.token
                })
      
        .then((response) => {
            callback(this.displayStringSearch(response.data.data))
        }).catch((err) => {
            if (axios.isCancel(err)) {
               
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
    }

    getDefaultOptions               =       ()              =>          {
        this.setState({defaultOptions : []});
        HttpAPICall.withAthorization('GET', this.emp_list_url, this.props.access_token,   this.state.params, {})
        .then((response) => {
            this.setState({
                defaultOptions:     this.displayStringSearch(response.data.data)
            });
        }).catch((err) => {
            if (axios.isCancel(err)) {
                
            } else {
                ErrorValidation.apiErrorHandle(err, 'Unable to Get / Save Application Data.');
            }
        });
    
    }
    
    render() {
        console.log({
    propSite: this.props.site_ids
});
          return (<Ax>
            <AsyncSelect
                styles          =   {ReactSelectStyle(this.props)}
                menuPlacement   =   {this.props.menuPlacement ? this.props.menuPlacement : "bottom"}
                placeholder     =   {this.props.placeholder || "Search Employee by Name" }
                loadingMessage  =   {(input) => {
                    if(input.inputValue && input.inputValue.length <=2 ) {
                        return 'Please enter 3 or more characters';
                    } else {
                        return 'Searching...';
                    }
                }}
                noOptionsMessage  =   {(input) => {
                    if(input.inputValue.length == 0) {
                        return 'Please enter 3 or more characters';
                    } else {
                        return 'No Employee found';
                    }
                }}
                minimumInput    =   {5}
                complete        =   {true}
                onChange        =   {this.onInputChange}
                isClearable     =   {true}
                loadOptions     =   {this.loadingOptions}
                value           =   {this.props.value}
                isMulti         =   {this.props.isMulti || false}
                required        =   {true}
                isDisabled      =   {this.props.disabled || false}
                defaultOptions  =   {this.props.loadDefaultOptions == true ? this.state.defaultOptions  : null }
            />
            <input
                name=''
                tabIndex={-1}
                required={this.props.required || false}
                value={this.props.isMulti ? (this.props.value.length > 0 ? this.props.value[0].label : [].join(' ')) : (this.props.value ? this.props.value.label : '')}
                onChange={() => {} }
                style={{
                    opacity: 0,
                    width: 0,
                    height: 0,
                    padding: 0,
                    margin: 0,
                    display: 'table'
                  }}
            />        
            </Ax>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token
    };
};

export default connect(mapStateToProps)(InputEmployeeSearch);